/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectStagesCreateProjectStagesPatch } from '../fn/project-stages/api-project-stages-create-project-stages-patch';
import { ApiProjectStagesCreateProjectStagesPatch$Params } from '../fn/project-stages/api-project-stages-create-project-stages-patch';
import { apiProjectStagesCreateProjectStagesPatch$Plain } from '../fn/project-stages/api-project-stages-create-project-stages-patch-plain';
import { ApiProjectStagesCreateProjectStagesPatch$Plain$Params } from '../fn/project-stages/api-project-stages-create-project-stages-patch-plain';
import { apiProjectStagesDeleteProjectStagesDelete } from '../fn/project-stages/api-project-stages-delete-project-stages-delete';
import { ApiProjectStagesDeleteProjectStagesDelete$Params } from '../fn/project-stages/api-project-stages-delete-project-stages-delete';
import { apiProjectStagesDeleteProjectStagesDelete$Plain } from '../fn/project-stages/api-project-stages-delete-project-stages-delete-plain';
import { ApiProjectStagesDeleteProjectStagesDelete$Plain$Params } from '../fn/project-stages/api-project-stages-delete-project-stages-delete-plain';
import { apiProjectStagesGetPathStagesPost } from '../fn/project-stages/api-project-stages-get-path-stages-post';
import { ApiProjectStagesGetPathStagesPost$Params } from '../fn/project-stages/api-project-stages-get-path-stages-post';
import { apiProjectStagesGetPathStagesPost$Plain } from '../fn/project-stages/api-project-stages-get-path-stages-post-plain';
import { ApiProjectStagesGetPathStagesPost$Plain$Params } from '../fn/project-stages/api-project-stages-get-path-stages-post-plain';
import { apiProjectStagesGetPatternPathsPost } from '../fn/project-stages/api-project-stages-get-pattern-paths-post';
import { ApiProjectStagesGetPatternPathsPost$Params } from '../fn/project-stages/api-project-stages-get-pattern-paths-post';
import { apiProjectStagesGetPatternPathsPost$Plain } from '../fn/project-stages/api-project-stages-get-pattern-paths-post-plain';
import { ApiProjectStagesGetPatternPathsPost$Plain$Params } from '../fn/project-stages/api-project-stages-get-pattern-paths-post-plain';
import { apiProjectStagesGetPatternsPost } from '../fn/project-stages/api-project-stages-get-patterns-post';
import { ApiProjectStagesGetPatternsPost$Params } from '../fn/project-stages/api-project-stages-get-patterns-post';
import { apiProjectStagesGetPatternsPost$Plain } from '../fn/project-stages/api-project-stages-get-patterns-post-plain';
import { ApiProjectStagesGetPatternsPost$Plain$Params } from '../fn/project-stages/api-project-stages-get-patterns-post-plain';
import { apiProjectStagesGetProjectStagesGet } from '../fn/project-stages/api-project-stages-get-project-stages-get';
import { ApiProjectStagesGetProjectStagesGet$Params } from '../fn/project-stages/api-project-stages-get-project-stages-get';
import { apiProjectStagesGetProjectStagesGet$Plain } from '../fn/project-stages/api-project-stages-get-project-stages-get-plain';
import { ApiProjectStagesGetProjectStagesGet$Plain$Params } from '../fn/project-stages/api-project-stages-get-project-stages-get-plain';
import { apiProjectStagesGetProjectSuitablePatternPathsGet } from '../fn/project-stages/api-project-stages-get-project-suitable-pattern-paths-get';
import { ApiProjectStagesGetProjectSuitablePatternPathsGet$Params } from '../fn/project-stages/api-project-stages-get-project-suitable-pattern-paths-get';
import { apiProjectStagesGetProjectSuitablePatternPathsGet$Plain } from '../fn/project-stages/api-project-stages-get-project-suitable-pattern-paths-get-plain';
import { ApiProjectStagesGetProjectSuitablePatternPathsGet$Plain$Params } from '../fn/project-stages/api-project-stages-get-project-suitable-pattern-paths-get-plain';
import { apiProjectStagesGetProjectSuitableStagesGet } from '../fn/project-stages/api-project-stages-get-project-suitable-stages-get';
import { ApiProjectStagesGetProjectSuitableStagesGet$Params } from '../fn/project-stages/api-project-stages-get-project-suitable-stages-get';
import { apiProjectStagesGetProjectSuitableStagesGet$Plain } from '../fn/project-stages/api-project-stages-get-project-suitable-stages-get-plain';
import { ApiProjectStagesGetProjectSuitableStagesGet$Plain$Params } from '../fn/project-stages/api-project-stages-get-project-suitable-stages-get-plain';
import { apiProjectStagesUpdateProjectStagePatch } from '../fn/project-stages/api-project-stages-update-project-stage-patch';
import { ApiProjectStagesUpdateProjectStagePatch$Params } from '../fn/project-stages/api-project-stages-update-project-stage-patch';
import { apiProjectStagesUpdateProjectStagePatch$Plain } from '../fn/project-stages/api-project-stages-update-project-stage-patch-plain';
import { ApiProjectStagesUpdateProjectStagePatch$Plain$Params } from '../fn/project-stages/api-project-stages-update-project-stage-patch-plain';
import { apiProjectStagesUpdateProjectStageStatusPatch } from '../fn/project-stages/api-project-stages-update-project-stage-status-patch';
import { ApiProjectStagesUpdateProjectStageStatusPatch$Params } from '../fn/project-stages/api-project-stages-update-project-stage-status-patch';
import { apiProjectStagesUpdateProjectStageStatusPatch$Plain } from '../fn/project-stages/api-project-stages-update-project-stage-status-patch-plain';
import { ApiProjectStagesUpdateProjectStageStatusPatch$Plain$Params } from '../fn/project-stages/api-project-stages-update-project-stage-status-patch-plain';
import { CreateProjectStagesCommandResult } from '../models/create-project-stages-command-result';
import { DeleteProjectStagesCommandResult } from '../models/delete-project-stages-command-result';
import { GetProjectPatternPathsQueryResult } from '../models/get-project-pattern-paths-query-result';
import { GetProjectPatternPathStagesQueryResult } from '../models/get-project-pattern-path-stages-query-result';
import { GetProjectPatternsQueryResult } from '../models/get-project-patterns-query-result';
import { GetProjectStagesQueryResult } from '../models/get-project-stages-query-result';
import { GetProjectSuitablePatternPathsQueryResult } from '../models/get-project-suitable-pattern-paths-query-result';
import { GetProjectSuitableStagesQueryResult } from '../models/get-project-suitable-stages-query-result';
import { UpdateProjectStageCommandResult } from '../models/update-project-stage-command-result';
import { UpdateProjectStageStatusCommandResult } from '../models/update-project-stage-status-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectStagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectStagesGetPatternsPost()` */
  static readonly ApiProjectStagesGetPatternsPostPath = '/api/ProjectStages/GetPatterns';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetPatternsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPatternsPost$Plain$Response(params?: ApiProjectStagesGetPatternsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternsQueryResult>> {
    return apiProjectStagesGetPatternsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetPatternsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPatternsPost$Plain(params?: ApiProjectStagesGetPatternsPost$Plain$Params, context?: HttpContext): Observable<GetProjectPatternsQueryResult> {
    return this.apiProjectStagesGetPatternsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPatternsQueryResult>): GetProjectPatternsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetPatternsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPatternsPost$Response(params?: ApiProjectStagesGetPatternsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternsQueryResult>> {
    return apiProjectStagesGetPatternsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetPatternsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPatternsPost(params?: ApiProjectStagesGetPatternsPost$Params, context?: HttpContext): Observable<GetProjectPatternsQueryResult> {
    return this.apiProjectStagesGetPatternsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPatternsQueryResult>): GetProjectPatternsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesGetPatternPathsPost()` */
  static readonly ApiProjectStagesGetPatternPathsPostPath = '/api/ProjectStages/GetPatternPaths';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetPatternPathsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPatternPathsPost$Plain$Response(params?: ApiProjectStagesGetPatternPathsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternPathsQueryResult>> {
    return apiProjectStagesGetPatternPathsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetPatternPathsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPatternPathsPost$Plain(params?: ApiProjectStagesGetPatternPathsPost$Plain$Params, context?: HttpContext): Observable<GetProjectPatternPathsQueryResult> {
    return this.apiProjectStagesGetPatternPathsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPatternPathsQueryResult>): GetProjectPatternPathsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetPatternPathsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPatternPathsPost$Response(params?: ApiProjectStagesGetPatternPathsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternPathsQueryResult>> {
    return apiProjectStagesGetPatternPathsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetPatternPathsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPatternPathsPost(params?: ApiProjectStagesGetPatternPathsPost$Params, context?: HttpContext): Observable<GetProjectPatternPathsQueryResult> {
    return this.apiProjectStagesGetPatternPathsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPatternPathsQueryResult>): GetProjectPatternPathsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesGetPathStagesPost()` */
  static readonly ApiProjectStagesGetPathStagesPostPath = '/api/ProjectStages/GetPathStages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetPathStagesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPathStagesPost$Plain$Response(params?: ApiProjectStagesGetPathStagesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternPathStagesQueryResult>> {
    return apiProjectStagesGetPathStagesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetPathStagesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPathStagesPost$Plain(params?: ApiProjectStagesGetPathStagesPost$Plain$Params, context?: HttpContext): Observable<GetProjectPatternPathStagesQueryResult> {
    return this.apiProjectStagesGetPathStagesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPatternPathStagesQueryResult>): GetProjectPatternPathStagesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetPathStagesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPathStagesPost$Response(params?: ApiProjectStagesGetPathStagesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPatternPathStagesQueryResult>> {
    return apiProjectStagesGetPathStagesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetPathStagesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesGetPathStagesPost(params?: ApiProjectStagesGetPathStagesPost$Params, context?: HttpContext): Observable<GetProjectPatternPathStagesQueryResult> {
    return this.apiProjectStagesGetPathStagesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPatternPathStagesQueryResult>): GetProjectPatternPathStagesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesGetProjectSuitablePatternPathsGet()` */
  static readonly ApiProjectStagesGetProjectSuitablePatternPathsGetPath = '/api/ProjectStages/GetProjectSuitablePatternPaths';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetProjectSuitablePatternPathsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectSuitablePatternPathsGet$Plain$Response(params?: ApiProjectStagesGetProjectSuitablePatternPathsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectSuitablePatternPathsQueryResult>> {
    return apiProjectStagesGetProjectSuitablePatternPathsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetProjectSuitablePatternPathsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectSuitablePatternPathsGet$Plain(params?: ApiProjectStagesGetProjectSuitablePatternPathsGet$Plain$Params, context?: HttpContext): Observable<GetProjectSuitablePatternPathsQueryResult> {
    return this.apiProjectStagesGetProjectSuitablePatternPathsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectSuitablePatternPathsQueryResult>): GetProjectSuitablePatternPathsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetProjectSuitablePatternPathsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectSuitablePatternPathsGet$Response(params?: ApiProjectStagesGetProjectSuitablePatternPathsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectSuitablePatternPathsQueryResult>> {
    return apiProjectStagesGetProjectSuitablePatternPathsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetProjectSuitablePatternPathsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectSuitablePatternPathsGet(params?: ApiProjectStagesGetProjectSuitablePatternPathsGet$Params, context?: HttpContext): Observable<GetProjectSuitablePatternPathsQueryResult> {
    return this.apiProjectStagesGetProjectSuitablePatternPathsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectSuitablePatternPathsQueryResult>): GetProjectSuitablePatternPathsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesGetProjectSuitableStagesGet()` */
  static readonly ApiProjectStagesGetProjectSuitableStagesGetPath = '/api/ProjectStages/GetProjectSuitableStages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetProjectSuitableStagesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectSuitableStagesGet$Plain$Response(params: ApiProjectStagesGetProjectSuitableStagesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectSuitableStagesQueryResult>> {
    return apiProjectStagesGetProjectSuitableStagesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetProjectSuitableStagesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectSuitableStagesGet$Plain(params: ApiProjectStagesGetProjectSuitableStagesGet$Plain$Params, context?: HttpContext): Observable<GetProjectSuitableStagesQueryResult> {
    return this.apiProjectStagesGetProjectSuitableStagesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectSuitableStagesQueryResult>): GetProjectSuitableStagesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetProjectSuitableStagesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectSuitableStagesGet$Response(params: ApiProjectStagesGetProjectSuitableStagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectSuitableStagesQueryResult>> {
    return apiProjectStagesGetProjectSuitableStagesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetProjectSuitableStagesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectSuitableStagesGet(params: ApiProjectStagesGetProjectSuitableStagesGet$Params, context?: HttpContext): Observable<GetProjectSuitableStagesQueryResult> {
    return this.apiProjectStagesGetProjectSuitableStagesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectSuitableStagesQueryResult>): GetProjectSuitableStagesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesGetProjectStagesGet()` */
  static readonly ApiProjectStagesGetProjectStagesGetPath = '/api/ProjectStages/GetProjectStages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetProjectStagesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectStagesGet$Plain$Response(params?: ApiProjectStagesGetProjectStagesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectStagesQueryResult>> {
    return apiProjectStagesGetProjectStagesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetProjectStagesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectStagesGet$Plain(params?: ApiProjectStagesGetProjectStagesGet$Plain$Params, context?: HttpContext): Observable<GetProjectStagesQueryResult> {
    return this.apiProjectStagesGetProjectStagesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectStagesQueryResult>): GetProjectStagesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesGetProjectStagesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectStagesGet$Response(params?: ApiProjectStagesGetProjectStagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectStagesQueryResult>> {
    return apiProjectStagesGetProjectStagesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesGetProjectStagesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectStagesGetProjectStagesGet(params?: ApiProjectStagesGetProjectStagesGet$Params, context?: HttpContext): Observable<GetProjectStagesQueryResult> {
    return this.apiProjectStagesGetProjectStagesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectStagesQueryResult>): GetProjectStagesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesCreateProjectStagesPatch()` */
  static readonly ApiProjectStagesCreateProjectStagesPatchPath = '/api/ProjectStages/CreateProjectStages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesCreateProjectStagesPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesCreateProjectStagesPatch$Plain$Response(params?: ApiProjectStagesCreateProjectStagesPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectStagesCommandResult>> {
    return apiProjectStagesCreateProjectStagesPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesCreateProjectStagesPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesCreateProjectStagesPatch$Plain(params?: ApiProjectStagesCreateProjectStagesPatch$Plain$Params, context?: HttpContext): Observable<CreateProjectStagesCommandResult> {
    return this.apiProjectStagesCreateProjectStagesPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectStagesCommandResult>): CreateProjectStagesCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesCreateProjectStagesPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesCreateProjectStagesPatch$Response(params?: ApiProjectStagesCreateProjectStagesPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectStagesCommandResult>> {
    return apiProjectStagesCreateProjectStagesPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesCreateProjectStagesPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesCreateProjectStagesPatch(params?: ApiProjectStagesCreateProjectStagesPatch$Params, context?: HttpContext): Observable<CreateProjectStagesCommandResult> {
    return this.apiProjectStagesCreateProjectStagesPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectStagesCommandResult>): CreateProjectStagesCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesUpdateProjectStagePatch()` */
  static readonly ApiProjectStagesUpdateProjectStagePatchPath = '/api/ProjectStages/UpdateProjectStage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesUpdateProjectStagePatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectStagesUpdateProjectStagePatch$Plain$Response(params?: ApiProjectStagesUpdateProjectStagePatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectStageCommandResult>> {
    return apiProjectStagesUpdateProjectStagePatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesUpdateProjectStagePatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectStagesUpdateProjectStagePatch$Plain(params?: ApiProjectStagesUpdateProjectStagePatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectStageCommandResult> {
    return this.apiProjectStagesUpdateProjectStagePatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectStageCommandResult>): UpdateProjectStageCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesUpdateProjectStagePatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectStagesUpdateProjectStagePatch$Response(params?: ApiProjectStagesUpdateProjectStagePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectStageCommandResult>> {
    return apiProjectStagesUpdateProjectStagePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesUpdateProjectStagePatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectStagesUpdateProjectStagePatch(params?: ApiProjectStagesUpdateProjectStagePatch$Params, context?: HttpContext): Observable<UpdateProjectStageCommandResult> {
    return this.apiProjectStagesUpdateProjectStagePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectStageCommandResult>): UpdateProjectStageCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesUpdateProjectStageStatusPatch()` */
  static readonly ApiProjectStagesUpdateProjectStageStatusPatchPath = '/api/ProjectStages/UpdateProjectStageStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesUpdateProjectStageStatusPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesUpdateProjectStageStatusPatch$Plain$Response(params?: ApiProjectStagesUpdateProjectStageStatusPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectStageStatusCommandResult>> {
    return apiProjectStagesUpdateProjectStageStatusPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesUpdateProjectStageStatusPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesUpdateProjectStageStatusPatch$Plain(params?: ApiProjectStagesUpdateProjectStageStatusPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectStageStatusCommandResult> {
    return this.apiProjectStagesUpdateProjectStageStatusPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectStageStatusCommandResult>): UpdateProjectStageStatusCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesUpdateProjectStageStatusPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesUpdateProjectStageStatusPatch$Response(params?: ApiProjectStagesUpdateProjectStageStatusPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectStageStatusCommandResult>> {
    return apiProjectStagesUpdateProjectStageStatusPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesUpdateProjectStageStatusPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesUpdateProjectStageStatusPatch(params?: ApiProjectStagesUpdateProjectStageStatusPatch$Params, context?: HttpContext): Observable<UpdateProjectStageStatusCommandResult> {
    return this.apiProjectStagesUpdateProjectStageStatusPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectStageStatusCommandResult>): UpdateProjectStageStatusCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectStagesDeleteProjectStagesDelete()` */
  static readonly ApiProjectStagesDeleteProjectStagesDeletePath = '/api/ProjectStages/DeleteProjectStages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesDeleteProjectStagesDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesDeleteProjectStagesDelete$Plain$Response(params?: ApiProjectStagesDeleteProjectStagesDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectStagesCommandResult>> {
    return apiProjectStagesDeleteProjectStagesDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesDeleteProjectStagesDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesDeleteProjectStagesDelete$Plain(params?: ApiProjectStagesDeleteProjectStagesDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectStagesCommandResult> {
    return this.apiProjectStagesDeleteProjectStagesDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectStagesCommandResult>): DeleteProjectStagesCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectStagesDeleteProjectStagesDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesDeleteProjectStagesDelete$Response(params?: ApiProjectStagesDeleteProjectStagesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectStagesCommandResult>> {
    return apiProjectStagesDeleteProjectStagesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectStagesDeleteProjectStagesDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectStagesDeleteProjectStagesDelete(params?: ApiProjectStagesDeleteProjectStagesDelete$Params, context?: HttpContext): Observable<DeleteProjectStagesCommandResult> {
    return this.apiProjectStagesDeleteProjectStagesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectStagesCommandResult>): DeleteProjectStagesCommandResult => r.body)
    );
  }

}
